import {Button} from '@material-ui/core';
import { changeCorrespondenceFilterPopup } from 'Agent/Policies/ducks/policyCorrespondence';
import {matchAsyncPage} from 'Core/models/Async';
import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import Loading from 'Shared/components/Loading';
import 'Shared/components/PagedView/Card/Card.sass';
import CardBody from 'Shared/components/PagedView/Card/CardBody';
import CardFilterOverlay, {CardFilters} from 'Shared/components/PagedView/Card/CardFilterOverlay';
import {SharedPagedProps} from 'Shared/components/PagedView/PagedView';
import CorrespondenceCardFilterOverlay from './CorrespondenceCardFilterOverlay';

export type ReactWindowProps<TData> = {
  dataItem: TData;
};

export type CardProps<TData> = SharedPagedProps<TData>;

const Card = <TData extends {}>(props: CardProps<TData>) => {
  const {columns, additionalFilterProperties} = props;
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const {filterCorrespondence} = useSelector(
    (state: ReducerState) => state.policyCorrespondence
  );
  const dispatch = useDispatch();
  const filters: Array<CardFilters<any>> = [
    ...columns.map(({title, filter}) => ({
      title,
      filter: filter!,
    })),
    ...(additionalFilterProperties || []),
  ].filter(item => Boolean(item.filter));
  const hasFilters = filters.length > 0;

  return (
    <>
      <CardFilterOverlay
        data={props.data}
        open={isFilterOpen}
        filters={filters}
        onClose={() => setIsFilterOpen(false)}
      />
      <CorrespondenceCardFilterOverlay
        open={filterCorrespondence}
        onClose={() => dispatch(changeCorrespondenceFilterPopup(false))}
      />
      {props.actions}
      {matchAsyncPage(props.data, {
        Loaded: data => (
          <>
            {hasFilters && (
              <Button
                fullWidth
                color="primary"
                className="paged-card__filter-button"
                onClick={() => setIsFilterOpen(true)}
              >
                <i className="fa fa-filter paged-card__filter-icon" />
                Filters
              </Button>
            )}
            {data.totalCount > 0 ? (
              <CardBody
                filters={filters}
                loadMore={props.loadMore}
                data={data}
                columns={columns}
                pagedViewKey={props.pagedViewKey}
              />
            ) : (
              <div className="paged-card__no-results-message">No Results Available.</div>
            )}
          </>
        ),
        Loading: () => <Loading />,

        Conflict: () => <div className="card__error">An error has occurred.</div>,
        ServerError: () => <div className="card__error">An error has occurred.</div>,
        Unauthorized: () => <div className="card__error">You are not authorized to access this resource.</div>,
        NoData: () => <div className="paged-table__content">No Results Available.</div>,
        NoContent: () => <div className="card__error">No Results Available.</div>,
        NotStarted: () => <div className="card__error">Choose Proper Filter.</div>
      })}
    </>
  );
};

export default Card;
